import type { ReactNode } from 'react';
import { featureFlags } from '../../utils/featureFlags';

export type OnboardingStep = 1 | 2 | 3;

export const CONSENT_GATE_STEP: OnboardingStep = featureFlags.onboardingConsentScreen ? 3 : 2;

/** This user's last screen, and how many they get — the dots must never promise more. */
export function lastOnboardingStep(showsDecisionScreens: boolean): OnboardingStep {
    return showsDecisionScreens ? CONSENT_GATE_STEP : 1;
}

export interface OnboardingDotsProps {
    total: number;
    /** 1-based index of the active screen. */
    current: number;
}

export interface OnboardingFooterProps {
    step: OnboardingStep;
    /** How many screens this user's walkthrough has — see {@link lastOnboardingStep}. */
    total: number;
    onBack: () => void;
    onNext: () => void;
    nextLabel: string;
    nextDisabled?: boolean;
    nextLoading?: boolean;
}

export interface OnboardingHeaderProps {
    title: string;
    subtitle?: string;
    testId?: string;
}

export interface ValuePropRowProps {
    icon: ReactNode;
    label: ReactNode;
    secondary?: ReactNode;
    disabled?: boolean;
    /** Omits the row divider — set on the last row of the list. */
    last?: boolean;
}

export interface ScreenConsentProps {
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
    onRefuseClick: () => void;
}

export interface ScreenRefusedProps {
    onContinue: () => void;
}
